﻿{
  "community": {
    "name": "Сообщество",
    "shortDescription": "Одна учетная запись с бесплатными заданиями",
    "features": [
      "Найди задания и поделись ими",
      "Неограниченное облачное хранилище заданий",
      "Доступ к премиальным заданиям"
    ],
    "price": "Бесплатно",
    "termName": "Пожизненно"
  },
  "personal": {
    "name": "Подписка для личного использования",
    "shortDescription": "Одна учетная запись с индивидуальными заданиями",
    "features": [
      "Создание и редактирование заданий в режиме онлайн",
      "Включает в себя личный список воспроизведения",
      "Доступ к заданиям на ходу"
    ]
  },
  "professional": {
    "name": "Подписка для специалистов",
    "shortDescription": "Одна учетная запись с множеством учащихся",
    "features": [
      "Управление назначениями учащихся",
      "Контроль прогресса учащихся ",
      "Сотрудничество с членами коллектива"
    ]
  },
  "organization": {
    "name": "Подписка для организаций",
    "shortDescription": "Множественные учетные записи с множеством учащихся",
    "features": [
      "Управление преподавателями",
      "Отчетность на уровне организации",
      "Настройки конфиденциальности на уровне предприятия"
    ],
    "price": "Свяжитесь с нами",
    "termName": "Срок от 1 до 5 лет"
  },
  "trialLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Предварительное ознакомление с редактором рабочего стола",
    "note": "Попробуйте <1>$t(common:action.free)</1> в течение 30 дней!",
    "price": "Бесплатно",
    "termName": "30-дневный пробный период",
    "footerNote": "1 установка"
  },
  "boardmakerLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Полный редактор рабочего стола",
    "note": "",
    "termName": "Разовая покупка",
    "footerNote": "2 установки для 1 пользователя"
  },
  "licenseRequest": {
    "name": "Boardmaker 7",
    "shortDescription": "Множественные лицензии для организации",
    "note": "",
    "price": "Свяжитесь с нами",
    "termName": "Скидки в зависимости от объемов",
    "footerNote": "2 установки для 1 пользователя"
  }
}
